<template>
  <form @submit.prevent="verify" @keydown="form.onKeydown($event)">
    <!-- Name -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">名前</label>
      <div class="col-md-7">
        <input v-model="form.name" :class="{ 'is-invalid': form.errors.has('name') }" class="form-control" type="text" name="name">
        <has-error :form="form" field="name"/>
      </div>
    </div>

    <!-- Office Name -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">会社・事務所名</label>
      <div class="col-md-7">
        <input v-model="form.office_name" :class="{ 'is-invalid': form.errors.has('office_name') }" class="form-control" type="text" name="office_name">
        <has-error :form="form" field="office_name"/>
      </div>
    </div>

    <!-- Job Position -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">役職</label>
      <div class="col-md-7 col-form-label">
        <b-form-radio-group v-model="form.job_position" id="job_position" name="job_position" :options="selects.job_position"/>
        <has-error :form="form" field="job_position"/>
      </div>
    </div>

    <!-- Email -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">メールアドレス</label>
      <div class="col-md-7">
        <input v-model="form.email" :class="{ 'is-invalid': form.errors.has('email') }" class="form-control" type="email" name="email">
        <has-error :form="form" field="email"/>
      </div>
    </div>

    <!-- Password -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">パスワード</label>
      <div class="col-md-7">
        <input v-model="form.password" :class="{ 'is-invalid': form.errors.has('password') }" class="form-control" type="password" name="password">
        <has-error :form="form" field="password"/>
      </div>
    </div>

    <!-- Password Confirmation -->
    <div class="form-group row">
      <label class="col-md-3 col-form-label text-md-right">確認用パスワード</label>
      <div class="col-md-7">
        <input v-model="form.password_confirmation" :class="{ 'is-invalid': form.errors.has('password_confirmation') }" class="form-control" type="password" name="password_confirmation">
        <has-error :form="form" field="password_confirmation"/>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-7 offset-md-3">
        <!-- Submit Button -->
        <v-button :loading="form.busy">
          無料会員登録
        </v-button>

        <hr>

        <div class="text-right">
          <!-- Facebook Login Button -->
          <login-with-facebook @success="$emit('success')">
            Facebookで無料会員登録
          </login-with-facebook>

          <!-- Google Login Button -->
          <login-with-google @success="$emit('success')">
            Googleで無料会員登録
          </login-with-google>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import Form from 'vform'
import LoginWithFacebook from '~/components/LoginWithFacebook'
import LoginWithGoogle from '~/components/LoginWithGoogle'

export default {
  middleware: 'guest',

  components: {
    LoginWithFacebook,
    LoginWithGoogle,
  },

  metaInfo () {
    return { title: '会員登録' }
  },

  data: () => ({
    form: new Form({
      name: '',
      office_name: '',
      job_position: '',
      email: '',
      password: '',
      password_confirmation: ''
    }),

    selects: {
      job_position: [
        { text: '代表・役員', value: 'ceo_officer' },
        { text: '事務所スタッフ', value: 'office_staff' },
        { text: '税理士受験生', value: 'accountant_examinee' },
      ]
    }
  }),

	mounted() {
    this.form.name = this.$route.query.name
    this.form.office_name = this.$route.query.office_name
    this.form.email = this.$route.query.email
  },

  methods: {
    async verify () {
      await this.$recaptcha('register').then((token) => {
        this.register()
      })
    },

    async register () {
      // Register the user.
      const { data } = await this.form.post('/api/register')

      // Log in the user.
      const { data: { token } } = await this.form.post('/api/login')

      // Save the token.
      this.$store.dispatch('auth/saveToken', { token })

      // Update the user.
      await this.$store.dispatch('auth/updateUser', { user: data })

      this.$emit('success')
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Register.vue